var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconBrandLinkedin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5197 2H3.47584C2.66153 2 2 2.64564 2 3.4413V20.5568C2 21.3533 2.66153 21.9998 3.47584 21.9998H20.5197C21.3355 21.9998 22 21.3533 22 20.5568V3.4413C22 2.64564 21.3355 2 20.5197 2ZM6.44913 4.75356C7.39735 4.75356 8.16801 5.52421 8.16801 6.47286C8.16801 7.42257 7.39735 8.19323 6.44913 8.19323C5.49815 8.19323 4.72855 7.42257 4.72855 6.47286C4.72855 5.52421 5.49815 4.75356 6.44913 4.75356ZM4.96524 19.0426H7.93175V9.49807H4.96524V19.0426ZM9.79217 9.49807H12.6375V10.8021H12.6771C13.0731 10.0517 14.0409 9.26075 15.4838 9.26075C18.4877 9.26075 19.0422 11.2375 19.0422 13.8071V19.0426H16.078V14.4009C16.078 13.2941 16.0574 11.8702 14.5365 11.8702C12.9928 11.8702 12.7559 13.0759 12.7559 14.3208V19.0426H9.79217V9.49807Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconBrandLinkedin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconBrandLinkedin.ec7faa0d26ca25870f63f7cf687742da.svg";